import { AuthGate } from "@/modules/auth";
import { ApplicationError, ApplicationLayout, appLoader } from ".";
import authRoutes from "./auth/routes";
import projectsRoutes from "./projects/routes";
import publicRoutes from "./public/routes";
import Settings from "./settings";

const appRoutes = [
  {
    path: "",
    element: <AuthGate />,
    errorElement: <ApplicationError />,
    children: [
      {
        path: "/",
        element: <ApplicationLayout />,
        loader: appLoader,
        id: "root",
        children: [
          ...projectsRoutes,
          {
            path: "settings",
            element: <Settings />,
          },
        ],
      },
      ...authRoutes,
    ],
  },
  ...publicRoutes,
];

export default appRoutes;
